
import { ObjectManager } from '../../../concepts/objects';
import { MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { TopicIndex } from '../../packages/topics/TopicIndex';
import { Camera } from '../Camera';
import { EditorSession } from '../EditorSession';
import { SpatialIndex } from '../utilities/SpatialIndex';
import { ToolBehavior } from './ToolBehavior';

export class DebugToolBehavior extends ToolBehavior {

    @resolve(Camera) private camera!: Camera;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(SpatialIndex) private spatialIndex!: SpatialIndex;
    @resolve(TopicIndex) private topicIndex!: TopicIndex;

    public init() {
    }

    public onMouseMove(state: string, mi: MouseInput): string | void {
        const { camera, spatialIndex } = this;

    }

    public onMouseDown(state: string, mi: MouseInput): string | void {
    }
}
